"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BustPose = void 0;
var BlazerblackteeV2_1 = require("./BlazerblackteeV2");
var Buttonshirt1V2_1 = require("./Buttonshirt1V2");
var ButtonShirt2V2_1 = require("./ButtonShirt2V2");
var CoffeeV2_1 = require("./CoffeeV2");
var DeviceV2_1 = require("./DeviceV2");
var DressV2_1 = require("./DressV2");
var ExplainingV2_1 = require("./ExplainingV2");
var GamingV2_1 = require("./GamingV2");
var GymShirtV2_1 = require("./GymShirtV2");
var HoodieV2_1 = require("./HoodieV2");
var JacketV2_1 = require("./JacketV2");
var KillerV2_1 = require("./KillerV2");
var MacbookV2_1 = require("./MacbookV2");
var PaperV2_1 = require("./PaperV2");
var PointingUpV2_1 = require("./PointingUpV2");
var PoloAndSweaterV2_1 = require("./PoloAndSweaterV2");
var ShirtAndCoatV2_1 = require("./ShirtAndCoatV2");
var SportyTeeV2_1 = require("./SportyTeeV2");
var StripedPocketTeeV2_1 = require("./StripedPocketTeeV2");
var StripedTeeV2_1 = require("./StripedTeeV2");
var SweaterDotsV2_1 = require("./SweaterDotsV2");
var SweaterV2_1 = require("./SweaterV2");
var Tee1V2_1 = require("./Tee1V2");
var Tee2V2_1 = require("./Tee2V2");
var TeeArmsCrossedV2_1 = require("./TeeArmsCrossedV2");
var TeeSelenaV2_1 = require("./TeeSelenaV2");
var ThunderTshirtV2_1 = require("./ThunderTshirtV2");
var TurtleneckV2_1 = require("./TurtleneckV2");
var WhateverV2_1 = require("./WhateverV2");
exports.BustPose = {
    BlazerblackteeV2: BlazerblackteeV2_1.BlazerblackteeV2,
    Buttonshirt1V2: Buttonshirt1V2_1.Buttonshirt1V2,
    ButtonShirt2V2: ButtonShirt2V2_1.ButtonShirt2V2,
    CoffeeV2: CoffeeV2_1.CoffeeV2,
    DeviceV2: DeviceV2_1.DeviceV2,
    DressV2: DressV2_1.DressV2,
    ExplainingV2: ExplainingV2_1.ExplainingV2,
    GamingV2: GamingV2_1.GamingV2,
    GymShirtV2: GymShirtV2_1.GymShirtV2,
    HoodieV2: HoodieV2_1.HoodieV2,
    JacketV2: JacketV2_1.JacketV2,
    KillerV2: KillerV2_1.KillerV2,
    MacbookV2: MacbookV2_1.MacbookV2,
    PaperV2: PaperV2_1.PaperV2,
    PointingUpV2: PointingUpV2_1.PointingUpV2,
    PoloAndSweaterV2: PoloAndSweaterV2_1.PoloAndSweaterV2,
    ShirtAndCoatV2: ShirtAndCoatV2_1.ShirtAndCoatV2,
    SportyTeeV2: SportyTeeV2_1.SportyTeeV2,
    StripedPocketTeeV2: StripedPocketTeeV2_1.StripedPocketTeeV2,
    StripedTeeV2: StripedTeeV2_1.StripedTeeV2,
    SweaterDotsV2: SweaterDotsV2_1.SweaterDotsV2,
    SweaterV2: SweaterV2_1.SweaterV2,
    Tee1V2: Tee1V2_1.Tee1V2,
    Tee2V2: Tee2V2_1.Tee2V2,
    TeeArmsCrossedV2: TeeArmsCrossedV2_1.TeeArmsCrossedV2,
    TeeSelenaV2: TeeSelenaV2_1.TeeSelenaV2,
    ThunderTshirtV2: ThunderTshirtV2_1.ThunderTshirtV2,
    TurtleneckV2: TurtleneckV2_1.TurtleneckV2,
    WhateverV2: WhateverV2_1.WhateverV2
};
